<template>
  <div id="app" class="app">
    <sfi-header></sfi-header>
    <tooltip-expanded></tooltip-expanded>
    <router-view />
    <help-contact />
    <sfi-footer></sfi-footer>
  </div>
</template>

<script>
import helpContact from '@/components/help-contact';

import tooltipExpanded from './components/shared/tooltip-expanded';

import sfiHeader from '@/components/shared/sfi-header';
import sfiFooter from '@/components/shared/sfi-footer';

export default {
  name: 'app',
  components: {
    helpContact,
    tooltipExpanded,
    sfiHeader,
    sfiFooter
  },
  created() {
    // Default to sfi insurance type
    const ins = 'sfi';
    // Capture test mode if passed via query param, and commit to store
    const testMode = this.$route.query.testMode ? this.$route.query.testMode.toLowerCase() : undefined;
    if (testMode !== undefined) {
      this.$store.commit('SET_TEST_MODE', testMode);
    }
    this.$store.dispatch('FETCH_INSURANCE_TYPE', ins);
    // Update returnUrl adding it the ins key route param or default key (sfm)
    if (ins) {
      this.$store.commit('UPDATE_RETURN_URL', ins);
    }
    // Check whether maintenance mode is enabled
    this.$store.dispatch('FETCH_MAINTENANCE_MODE_STATUS')
      .then((isMaintenanceMode) => {
        if (isMaintenanceMode) {
          this.redirectToPage('maintenance');
        }
      })
      .catch(() => {
        setTimeout(function () {
          this.goToPage('error');
        }, 0);
      });
  }
}
</script>

<style lang="scss">
@import './styles/global.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue